module.exports = __webpack_public_path__ + "img/icon_write.ba25823b.svg";